<template>
    <div>
        <vs-popup title="Escolha a forma que deseja fazer baixar a lista de contatos:" 
        :active.sync="isActive"
        @close="$emit('isActiveFalse')"
        style="border-radius: 10px !important;"
        id="erprootmodal"
        class="sizePopup"
        >

        <span style="margin: 2%; font-size: 120%"><b>Selecione como deseja baixar:</b></span>
        <div class="flex" style="margin-bottom: 2em;">
            <div class="w-3/12" style="text-align: center; margin-left: 3%;">
                <div class="w-full mt-4 flex justify-center items-center">
                    <span style="width: 10em;">Todos os Contatos:</span>
                </div>
                <div class="w-full mt-4 flex justify-center items-center">
                    <vs-checkbox v-model="downloadAllCustomersSheet"></vs-checkbox>
                </div>
            </div>

            <div class="w-3/12" style="text-align: center; margin-left: 10%;">
                <div class="w-full mt-4 flex justify-center items-center">
                    <span style="width: 10em;">Por Conexão:</span>
                </div>
                <div class="w-full mt-4 flex justify-center items-center">
                    <vs-checkbox v-model="downloadByInstanceSheet"></vs-checkbox>
                </div>
            </div>

            <div class="w-3/12" style="text-align: center; margin-left: 9%;">
                <div class="w-full mt-4 flex justify-center items-center">
                    <span style="width: 10em;">Por Período:</span>
                </div>
                <div class="w-full mt-4 flex justify-center items-center">
                    <vs-checkbox v-model="downloadByDateSheet"></vs-checkbox>
                </div>
            </div>
        </div>

        <span style="margin: 2%; font-size: 120%;"><b>Selecione a quantidade de planilha(s):</b></span>
        <div class="centerx"  style="margin: 2%; width: 5em; margin-left: 45%; transform: translateY(2em);">
            <vs-input-number v-model="filterPeriod.quantity" :step="1" min="1" max="50"/>
        </div>

        <div v-if="downloadByInstanceSheet" style="margin-top: 5em;">
            <span style="margin: 2%; font-size: 120%"><b>Selecione a instância:</b></span>
            <div class="w-full flex justify-center items-center">
                <div class="w-6/12 flex justify-center items-center" style="flex-direction: column; margin-top: 3em;">
                <div class="w-full flex justify-center items-center">
                    <span class="phone-number-span">Conexão:</span>
                </div>
                <v-select
                    style="width: 100%"
                    class="w-full"
                    v-model="filterPeriod.instance"
                    :options="instances"
                />
                </div>
            </div>
        </div>

        <div v-if="downloadByDateSheet" style="margin-top: 5em;">
            <span style="margin: 2%; font-size: 120%"><b>Filtrar contatos por periodo:</b></span>
            <div class="w-full mt-4 mb-4 flex justify-center items-center flex-direction-row">
                <div class="w-3/12 flex justify-center items-center mr-12" style="flex-direction: column; margin-left: 3em;">
                    <div class="w-full flex justify-center items-center">
                        <span class="phone-number-span">
                        Data Inicial
                        </span>
                    </div>
    
                    <div class="w-full flex justify-center items-center">
                        <flat-pickr
                            :config="configDatePicker"
                            v-model="filterPeriod.date_start_at"
                            placeholder="Escolha uma Data"
                        />
                    </div>
                </div>

                <div class="w-3/12 flex justify-center items-center mr-12" style="flex-direction: column; margin-left: 3em;">
                    <div class="w-full flex justify-center items-center">
                        <span class="phone-number-span">
                        Data Final
                        </span>
                    </div>
    
                    <div class="w-full flex justify-center items-center">
                        <flat-pickr
                            :config="finishAtConfig(configDatePicker)"
                            v-model="filterPeriod.date_finish_at"
                            placeholder="Escolha uma Data"
                            :disabled="filterPeriod.date_start_at === null"
                        />
                    </div>
                </div>
    
            </div>
        </div>

        <vs-button
            color="primary"
            type="filled"
            class="align-right mr-5 mb-4"
            style="float: right; margin-top: 3em;"
            @click.prevent="sendData"
        >
            <span>Baixar</span>
        </vs-button>

        </vs-popup>
    </div>
</template>

<script>
    import 'flatpickr/dist/flatpickr.css'
    import flatPickr               from 'vue-flatpickr-component'
    import { VTree, VSelectTree }  from 'vue-tree-halower'
    import vSelect                 from 'vue-select'
    import moduleInstance          from '@/store/instance/moduleInstance';
    import customerApi             from '@/http/requests/customer'
    import axios                   from 'axios'

    export default {
        name: 'DownloadCustomers',
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'isActiveFalse'
        ],
        components: {
            flatPickr,
            vSelect,
            VTree,
            VSelectTree
        },
        data() {
            return {
                downloadAllCustomersSheet: true,
                downloadByDateSheet: false,
                downloadByInstanceSheet: false,
                instances: [],
                configDatePicker: {
                    enableTime: false,
                    noCalendar: false,
                    time_24hr: true,
                    dateFormat: 'd/m/Y',
                    maxDate: new Date().setDate(new Date().getDate()),
                },
                filterPeriod: {
                    downloadAllCustomersSheet: true,
                    quantity: 1,
                    date_start_at: '',
                    date_finish_at: '',
                    downloadByInstanceSheet: false,
                    instance: '',
                }
            }
        },
        watch: {
            downloadAllCustomersSheet(newValue) {
                this.filterPeriod.downloadAllCustomersSheet = newValue
                if (newValue) {
                    this.downloadByDateSheet     = false;
                    this.downloadByInstanceSheet = false;
                } else if (!this.downloadByDateSheet && !this.downloadByInstanceSheet) {
                    this.downloadByDateSheet = true;
                    this.filterPeriod.downloadAllCustomersSheet = true;
                }
            },
            downloadByDateSheet(newValue) {
                this.filterPeriod.downloadByDateSheet = newValue
                if (newValue) {
                    this.downloadAllCustomersSheet = false;
                    this.downloadByInstanceSheet   = false;
                } else if (!this.downloadAllCustomersSheet && !this.downloadByInstanceSheet && !this.downloadByDateSheet) {
                    this.downloadAllCustomersSheet = true;
                    this.filterPeriod.downloadAllCustomersSheet = true;
                }
            },
            downloadByInstanceSheet(newValue) {
                this.filterPeriod.downloadByInstanceSheet = newValue
                if (newValue) {
                    this.downloadByDateSheet       = false;
                    this.downloadAllCustomersSheet = false;
                } else if (!this.downloadAllCustomersSheet && !this.downloadByInstanceSheet && !this.downloadByDateSheet) {
                    this.downloadAllCustomersSheet = true;
                    this.filterPeriod.downloadAllCustomersSheet = true;
                }
            }
        },
        methods: {
            finishAtConfig(config) {
                return {
                ...config,
                    minDate: this.filterPeriod.date_start_at
                }
            },
            formatDate(data) {
                const dia = data.split("/")[0];
                const mes = data.split("/")[1];
                const ano = data.split("/")[2];

                return `${dia}-${mes}-${ano}`;
            },
            alertQuantitySheet(quantity) {
                let whichBrowser = this.getBrowserType();
                let whichSystem = this.getSystemType();
                
                if (whichBrowser === "Chrome" && whichSystem === "Linux" && quantity > 10) {
                    this.$vs.notify({
                        time: 8000,
                        title: 'Aviso de Download',
                        text: 'Você está usando o Chrome no Linux, informamos que pode haver uma limitação para baixar planilhas simultaneamente no valor de 10 planilhas.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }
            },
            getBrowserType() {
                const userAgent = navigator.userAgent;
                const browser = userAgent.match(/(Chrome|Firefox|Edge|Safari|Opera)/i);

                if (browser) {
                    return browser[1];
                } else {
                    return "Unknown";
                }
            },
            getSystemType() {
                const system = window.navigator.userAgent.match(/(Windows|Linux|Mac|Android|iOS)/i)[0];
                if (system) {
                    return system;
                } else {
                    return "Unknown";
                }
            },
            downloadDocument(url, documentName, documentMimetype) {
                axios.get(url, {
                    responseType: 'blob'
                }).then(res => {
                    var blob = new Blob(
                        [res.data],
                        { type: `${documentMimetype};charset=utf-8;` }
                    )
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = documentName
                    link.click()
                    window.URL.revokeObjectURL(link.href)
                })
        },
            async sendData() {
                if (this.downloadByInstanceSheet && this.filterPeriod.instance === '') {
                    this.$vs.notify({
                        title: 'Erro',
                        text: 'Selecione pelo menos uma opção uma instância',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return
                    
                }

                if (this.downloadByDateSheet && this.filterPeriod.date_start_at === '' && this.filterPeriod.date_finish_at === '') {
                    this.$vs.notify({
                        title: 'Erro',
                        text: 'Selecione pelo menos uma opção um período',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return
                }

                let formattedData = {
                    quantity: this.filterPeriod.quantity,
                    date_start_at: this.filterPeriod.date_start_at ? this.formatDate(this.filterPeriod.date_start_at) : '',
                    date_finish_at: this.filterPeriod.date_finish_at ? this.formatDate(this.filterPeriod.date_finish_at) : '',
                    downloadAllCustomersSheet: this.filterPeriod.downloadAllCustomersSheet,
                    downloadByInstanceSheet: this.filterPeriod.downloadByInstanceSheet,
                    instance: this.filterPeriod.instance ? this.filterPeriod.instance.id : 0,
                }

                this.alertQuantitySheet(formattedData.quantity);

                try {
                    let data = customerApi.downloadListCustomers(
                        formattedData.instance,
                        formattedData.downloadAllCustomersSheet,
                        formattedData.quantity,
                        formattedData.date_start_at,
                        formattedData.date_finish_at,
                        formattedData.downloadByInstanceSheet,
                    ).then(res => {
                        const formattedString = res.data.data.downloadCustomer.replace(/\\/g, '');
                        const urls = JSON.parse(formattedString);

                        urls.forEach((url) => {
                            let name = `LISTA_DE_CONTATOS.xlsx`;

                            if (formattedData.downloadByInstanceSheet == true) {
                                name = `LISTA_DE_CONTATOS_POR_INSTANCIA_${this.filterPeriod.instance.label}.xlsx`;
                            } else if (this.downloadByDateSheet == true) {
                                if (formattedData.date_start_at === formattedData.date_finish_at) {
                                    name = `LISTA_DE_CONTATOS_POR_DATA_${formattedData.date_start_at}.xlsx`;
                                } else {
                                    name = `LISTA_DE_CONTATOS_POR_DATA_${formattedData.date_start_at}_${formattedData.date_finish_at}.xlsx`;
                                }
                            }

                            this.downloadDocument(url, name, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        })
                    });

                    this.$emit('isActiveFalse');
                    this.$vs.loading.close();

                    return data

                } catch (exception) {
                    console.log(exception);
                    this.$vs.loading.close();

                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Houve algum erro ao baixar as planilhas!'
                    });
                }
            }
        },
        async mounted() {
            if (!moduleInstance.isRegistered) {
                this.$store.registerModule('instance', moduleInstance)
                moduleInstance.isRegistered = true
            }

            this.$store.dispatch('instance/fetch').then(() => {
                let getInstances = this.$store.state.instance.instances;
                getInstances.forEach((instance) => {
                    let data = {
                        id: instance.id,
                        phone_number: instance.phone_number,
                        label: instance.name,
                        active: instance.activated
                    }
                    this.instances.push(data)
                })
            })
            await this.loadingData();
        },
    }
</script>

<style>
    #erprootmodal * {
        margin: 0;
    }
    #erprootmodal html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    #erprootmodal table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
        background-color: white !important;
    }
    #erprootmodal .vs-con-tbody.vs-table--tbody {
        border: 0 !important;
    }
    #erprootmodal tbody > tr {
        height: 5em;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
    }
    #erprootmodal thead > tr {
        background-color: transparent !important;
    }
    #erprootmodal .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
    }
    #erprootmodal input.input-search.vs-table--search-input {
        height: 45px;
    }
</style>
